<div class="container text-center mb-5 mt-4" style="max-width: 40rem;">
  <h1 class="jumbotron-heading">Maintenance...</h1>
  <p class="lead text-muted">Sorry! Currently, you can't {{action()}} because we're doing maintenance on
    the service. Please come back later.</p>
</div>
